export default {
	title: 'A faire avant la fin du {mois}<sup>ème</sup> mois',
	affichersuite: 'Afficher la suite',
	affichermoins: 'Afficher moins'
};
